<template lang='pug'>
  div
    v-dialog(v-model='dialog', width='800')
      v-card
        v-card-title.headline.primary.white--text(primary-title)
          | {{ $tc('words.edit') | capitalize }}
        div(v-if="user.role === 'admin'")
          v-tabs(v-model="tabActive" color="primary" slider-color="white" dark centered)
            v-tab(key="tab-edit")
              | Editar
            v-tab(key="tab-version")
              | Auditoria
          v-tabs-items(v-model="tabActive")
            v-tab-item(key="tab-edit")
              v-card-text
                u-form(v-model="result", :json="json", :resultJSON="true")
              v-divider
              v-card-actions
                v-spacer
                v-btn(color='default', flat, @click='dialog = false') {{ $t('words.cancel') }}
                v-btn(color='primary', @click='save') {{ $t('words.save') }}
            v-tab-item(key="tab-version")
              v-flex.md3.xs3(class="d-flex ml-auto mr-3")
                v-text-field(label:="quantidade de busca" v-model="searchNumber" type="number")
                v-btn(:loading="loading" color='primary', @click="searchVersions()") {{'buscar'}}
              div(v-if="changes.length > 0")
                v-container
                  v-data-table.data-table.elevation-1(
                    :loading="loading"
                    :headers="headers"
                    :items="paginatedItems"
                    :total-items="changes.length"
                    :pagination.sync='pagination'
                  )
                    template(slot="items" slot-scope="props")
                      tr
                        td {{ props.item.date | formatDateTime }}
                        td
                          span(v-html="processedValue(props.item.value)")
                        td.text-xs-right
                          v-btn(
                            color="primary"
                            small
                            @click.stop="restoreVersion(props.index)"
                          ) Restaurar
        div(v-else)
          v-card-text
            u-form(v-model="result", :json="json", :resultJSON="true")
          v-divider
          v-card-actions
            v-spacer
            v-btn(color='default', flat, @click='dialog = false') {{ $t('words.cancel') }}
            v-btn(color='primary', @click='save') {{ $t('words.save') }}

</template>

<script>

import {db} from '@/store/firebase'
import UForm from '@/components/form/form'
import firestoreUtil from '@/utils/firestore'
import {mapState} from 'vuex'

import formEditExam from '@/../functions/shared/formEditExam.json'

import axios from 'axios'

export default {
  name: 'uf-editExam',

  computed: {
    ...mapState({
      user: state => state.user,
      company: state => state.company,
      companyDoc: (state) => state.ultraFetal.company,
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction
    }),
    paginatedItems () {
      let start = (this.pagination.page - 1) * this.pagination.itemsPerPage
      let end = 1
      if (this.pagination.rowsPerPage > 0 && this.pagination.rowsPerPage < this.pagination.itemsPerPage) {
        end = start + this.pagination.itemsPerPage
      } else if (this.pagination.rowsPerPage < 0) {
        end = this.changes.length
        start = 0
      } else {
        end = start + this.pagination.rowsPerPage
      }
      return this.changes.slice(start, end)
    }
  },

  props: {
    iuid: {
      type: String
    },
    value: {
      type: Boolean
    }
  },

  components: {
    UForm
  },

  watch: {
    value (val) {
      this.dialog = val
      if (val) {
        this.init()
      }
    },
    dialog (val) {
      if (!val) {
        this.result = {}
        this.changes = []
        this.versions = []
      }
      this.$emit('input', val)
    }
  },

  data () {
    return {
      dialog: false,
      result: {},
      json: formEditExam.components[0],
      originalPatId: null,
      doctors: [],
      studyAn: null,
      tabActive: null,
      changes: [],
      versions: [],
      loading: false,
      headers: [
        { text: 'Data', value: 'date', align: 'center', sortable: false },
        { text: 'Valor', value: 'value', align: 'start', sortable: false },
        { text: 'Ações', value: 'actions', align: 'end', sortable: false }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 5
      },
      searchNumber: 10
    }
  },

  mounted () {
    this.insertDoctors()
  },

  methods: {
    async init () {
      db.collection('gestationInteraction').doc(this.iuid).get().then(data => {
        if (!data.exists) return
        let gestationData = firestoreUtil.docToObject(data)
        if (gestationData.gestation) delete gestationData.gestation
        if (!gestationData.forms) gestationData.forms = {}
        this.originalPatId = gestationData.patient.patId
        if (!gestationData.forms['gestationalAge.info.accessionNumber'] && gestationData.studies) {
          Object.assign(gestationData.forms, {'gestationalAge.info.accessionNumber': gestationData.studies[Object.keys(gestationData.studies)[0]].accessionNumber})
        }
        this.studyAn = gestationData.forms['gestationalAge.info.accessionNumber']
        if (!gestationData.forms.title && gestationData.studies && gestationData.studies[Object.keys(gestationData.studies)[0]].title) {
          Object.assign(gestationData.forms, {title: gestationData.studies[Object.keys(gestationData.studies)[0]].title})
        }
        this.result = {gestationInteraction: {}}
        this.result.gestationInteraction.company = gestationData.company
        this.result.gestationInteraction.iuid = gestationData.iuid
        this.result.gestationInteraction.date = gestationData.date
        this.result.gestationInteraction.patient = gestationData.patient
        if (gestationData.doctor) this.result.gestationInteraction.doctor = gestationData.doctor
        this.result.gestationInteraction.forms = {}
        this.result.gestationInteraction.forms.title = gestationData.forms.title
        this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber'] = gestationData.forms['gestationalAge.info.accessionNumber']
        if (gestationData.studies) this.result.gestationInteraction.studies = gestationData.studies
        if (gestationData.referringDoctor) this.result.gestationInteraction.referringDoctor = gestationData.referringDoctor
      })
    },
    async save () {
      // Ajusta StudyDate
      const studyDate = this.result.gestationInteraction.date
      if (studyDate) {
        this.result.gestationInteraction.studyDate = studyDate.toISOString().substring(0, 10)
        this.result.gestationInteraction.forms['gestationalAge.info.interationDate'] = studyDate
      }
      // Ajustar AN
      if (this.result.gestationInteraction.forms && this.result.gestationInteraction.forms.gestationalAge && this.result.gestationInteraction.forms.gestationalAge.info.accessionNumber) {
        this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber'] = this.result.gestationInteraction.forms.gestationalAge.info.accessionNumber
        delete this.result.gestationInteraction.forms.gestationalAge
      }
      if (this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber'] && this.result.gestationInteraction.studies) {
        this.result.gestationInteraction.studies[Object.keys(this.result.gestationInteraction.studies)[0]].accessionNumber = this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber']
      }

      // Ajustar TITULO
      if ((this.result.gestationInteraction.forms.title || this.result.gestationInteraction.forms.title === '') && this.result.gestationInteraction.studies) {
        this.result.gestationInteraction.studies[Object.keys(this.result.gestationInteraction.studies)[0]].title = this.result.gestationInteraction.forms.title
      }
      if (!this.result.gestationInteraction.studies) delete this.result.gestationInteraction.forms.title

      // MEDICO EXECUTOR
      if (this.result.gestationInteraction.doctor && this.result.gestationInteraction.doctor.id) {
        let doctor = this.doctors.find((element) => element.iuid === this.result.gestationInteraction.doctor.id)
        if (doctor) {
          if (doctor.crm) {
            this.result.gestationInteraction.doctor.identity = doctor.crm
          } else {
            this.result.gestationInteraction.doctor.identity = null
          }
          this.result.gestationInteraction.doctor.name = doctor.displayName
        }
      }

      if (this.originalPatId !== this.result.gestationInteraction.patient.patId) this.updateDicomImages()

      db.collection('gestationInteraction').doc(this.result.gestationInteraction.iuid).set({
        ...this.result.gestationInteraction
      }, { merge: true })
        .then(() => {
          alert(this.$t('messages.savedSuccessfully') + '!')
          this.dialog = false
        })
        .catch((err) => {
          console.log(err)
          alert(this.$t('messages.anErrorHasOccurred') + '! ' + err.toString())
        })

      // Atualizar Studies AN
      if (this.studyAn !== this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber']) {
        this.changeAnInStudies()
        db.doc('gestationInteraction/' + this.result.gestationInteraction.iuid).update({ studies: this.result.gestationInteraction.studies })
      }
    },
    async updateDicomImages () {
      await this.$store.dispatch('updateDicomImages', {
        dicomStoreId: this.result.gestationInteraction.company.identity,
        patId: this.originalPatId,
        accessionNumber: this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber'],
        StudyDate: this.formatDate(this.result.gestationInteraction.date),
        newPatId: this.result.gestationInteraction.patient.patId
      })
    },
    formatDate (isoString) {
      const date = new Date(isoString)
      const year = date.getUTCFullYear()
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const day = String(date.getUTCDate()).padStart(2, '0')
      return `${year}${month}${day}`
    },
    insertDoctors () {
      db.collection('users').where('companies', 'array-contains', this.company).where('role', '==', 'doctor').get().then(async queryUser => {
        if (queryUser.empty) return
        queryUser.docs.forEach(item => {
          this.doctors.push(firestoreUtil.docToObject(item))
        })
        this.doctors.forEach((doctor) => {
          this.json.components[4].items.push({'text': doctor.displayName, 'value': doctor.iuid})
        })
      })
    },

    changeAnInStudies () {
      let studyNewAn = this.result.gestationInteraction.forms['gestationalAge.info.accessionNumber']
      let newStudy = {[studyNewAn]: this.result.gestationInteraction.studies[this.studyAn]}
      delete this.result.gestationInteraction.studies[this.studyAn]
      this.result.gestationInteraction.studies = newStudy
    },

    async searchVersions () {
      this.changes = []
      this.loading = true
      try {
        const url = 'https://us-central1-ultracarebr.cloudfunctions.net/searchExamVersions'
        let response = await axios.post(url, { iuid: this.result.gestationInteraction.iuid, limit: this.searchNumber })
        if (!this.dialog) {
          console.log('Função interrompida porque a modal foi fechada')
          return
        }
        this.changes = response.data.changes
        this.versions = response.data.exams
      } catch (e) {
        console.log('erro : ', e)
      } finally {
        this.loading = false
      }
    },

    processedValue (value) {
      // Manipula o valor para estilizar conteúdo dentro da tag <strong>
      let formated = ''
      formated = value.replace(/<strong>(.*?)<\/strong>/g, '<span style="font-weight: bold;">$1</span>')
      formated = formated.replace(/<color>(.*?)<\/color>/g, '<span style="color: #199995;">$1</span>')
      formated = formated.replace(/<i>(.*?)<\/i>/g, '<span style="font-style: italic">$1</span>')
      return formated
    },

    restoreVersion (index) {
      try {
        this.$swal.fire({
          type: 'warning',
          title: 'deseja restaurar o exame para está versão?',
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'SIM',
          cancelButtonText: 'NÃO'
        }).then(async (result) => {
          if (result.value) {
            const version = this.versions[index + 1]
            if (version.forms) {
              Object.entries(version.forms).forEach(data => {
                const key = data[0]
                const val = data[1]
                if (val && typeof val === 'object' && val !== null && val['_seconds']) {
                  const date = new Date(1970, 0, 1)
                  date.setSeconds(val['_seconds'])
                  version.forms[key] = date
                }
              })
            }
            db.collection('gestationInteraction').doc(this.result.gestationInteraction.iuid).update({
              forms: version.forms
            }).then(() => {
              alert('versão restaurada com sucesso')
            })
          }
        })
      } catch (e) {
        this.$swal.fire({
          type: 'error',
          title: 'Erro ao restaurar versão',
          text: e,
          showCancelButton: false,
          showConfirmButton: true
        })
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/util/EditExam.vue